module.exports = __webpack_public_path__ + "static/img/20008 (2).0fb94b8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20008 (2).webp
// module id = MTGZ
// module chunks = 14